import Circle from "./Circle"
import Hexagone from "./Hexagone"
import Dodecagon from "./Dodecagon"
import Shield from "./Shield"

export { Circle, Hexagone, Dodecagon, Shield }
